import React from 'react';

import { NotFound } from 'modules/errors';

function NoMatchPage() {
    return <NotFound />;
}

export default NoMatchPage;
